// extracted by mini-css-extract-plugin
export default {"btn":"AddButton_btn__2P9bF","btnIcon":"AddButton_btnIcon__CCKK8"};